<div class="dropdown custom-dropdown" [class.show]="open">

    <!-- Campo principal -->
    <button class="form-control text-left dropdown-toggle" (click)="toggle()">

        {{ labelSelecionado || 'Todos' }}
    </button>

    <!-- Painel -->
    <div class="dropdown-menu w-100 p-2" [class.show]="open">

        <!-- Busca -->
        <input type="text" class="form-control mb-2" placeholder="Procurar" [(ngModel)]="searchTerm"
            (ngModelChange)="onSearch()" />

        <!-- Lista -->
        <div class="hierarchy-list">

            <div *ngFor="let pessoa of pessoas" class="hierarchy-item">

                <!-- Pessoa -->
                <div class="d-flex align-items-center">
                    <span (click)="togglePessoa(pessoa)">
                        <i class="fa" [ngClass]="pessoa.expanded ? 'fa-chevron-down' : 'fa-chevron-right'">
                        </i>
                    </span>
                    <input
                    type="checkbox"
                    class="mr-2"
                    (change)="select(pessoa)" />
                    {{ pessoa.nome }}
                </div>

                <!-- Categorias -->
                <div *ngIf="pessoa.expanded" class="ml-3">

                    <div *ngFor="let cat of pessoa.categorias">

                        <div class="category" (click)="toggleCategoria(pessoa, cat)">
                            {{ cat.label }}
                        </div>

                        <!-- Itens finais -->
                        <div *ngIf="cat.expanded" class="ml-3">

                            <div *ngFor="let item of cat.itens">
                                <input type="checkbox" (change)="select(item)" />
                                {{ item.nome }}
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</div>